module.exports = __webpack_public_path__ + "img/ico-rough-construction-completion.708e79c5.svg";